import { useEffect, useState } from 'react';
import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';

export default function useShareStats(activationId: number) {
    const authenticatedApi = useAuthenticatedApi();
    const [totalShares, setTotalShares] = useState(0);
    const [emailShares, setEmailShares] = useState(0);
    const [smsShares, setSmsShares] = useState(0);
    const [shares, setShares] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { orgId } = useUserOrg();

    useEffect(() => {
        const getShareStats = async () => {
            setIsLoading(true);
            try {
                const response = await authenticatedApi.get(
                    `/${orgId}/shares/activation/${activationId}/media`,
                );

                const data = response.data;

                setTotalShares(data.length);
                setEmailShares(
                    data.filter((share: any) => share.destination.includes('@'))
                        .length,
                );
                setSmsShares(
                    data.filter(
                        (share: any) => !share.destination.includes('@'),
                    ).length,
                );
                const csvShares = data.map((share: any) => ({
                    destination: share.destination,
                    mediaUrl: share.originalUri,
                    createdAt: share.createdAt,
                }));
                setShares(csvShares);
            } catch (error) {
                console.error('Error fetching share stats', error);
            }
            setIsLoading(false);
        };

        getShareStats();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId]);

    return {
        totalShares,
        emailShares,
        smsShares,
        shares,
        isLoading,
    };
}
